import {
  FlagEnIcon,
  FlagEsIcon,
  FlagPlIcon,
  FlagUkIcon,
  FlagViIcon,
} from 'icons';

export const LANGUAGE_LIST = [
  {
    value: 'pl',
    labelTranslation: 'common:lang.polish',
    Icon: FlagPlIcon,
  },
  {
    value: 'en',
    labelTranslation: 'common:lang.english',
    Icon: FlagEnIcon,
  },
  {
    value: 'es',
    labelTranslation: 'common:lang.spanish',
    Icon: FlagEsIcon,
  },
  {
    value: 'uk',
    labelTranslation: 'common:lang.ukrainian',
    Icon: FlagUkIcon,
  },
  {
    value: 'vi',
    labelTranslation: 'common:lang.vietnamese',
    Icon: FlagViIcon,
  },
] as const;
